const home = resolve => require(["@/page/home"], resolve);
const loan = resolve => require(["@/page/loan"], resolve);
const repayment = resolve => require(["@/page/repayment"], resolve);
const contact = resolve => require(["@/page/contact"], resolve);
const personal = resolve => require(["@/page/personal"], resolve);
const routes = [
    {
        path: "/",
        redirect: '/home',
    },
    {
        path: "/home",
        name: "home",
        component: home,
        meta: {
            headTitle: "home"
        }
    },
    {
        path: "/loan",
        name: "loan",
        component: loan,
        meta: {
            headTitle: "loan"
        }
    },
    {
        path: "/repayment",
        name: "repayment",
        component: repayment,
        meta: {
            headTitle: "repayment"
        }
    },
    {
        path: "/contact",
        name: "contact",
        component: contact,
        meta: {
            headTitle: "contact"
        }
    },
    {
        path: "/personal",
        name: "personal",
        component: personal,
        meta: {
            headTitle: "personal"
        }
    }
]

export default routes;
